import { useSearchParams } from "react-router-dom";
import EmptyState from "../../../../components/empty-state";
import Download from "../../../../components/icons/download";
import Loading from "../../../../components/loading";
import { AdminChartsState } from "../hooks/use-admin-charts";
import AdminChartDisplay from "./admin-charts-display";
import { ChartTypeEnum } from '../../../../models/chart';

type AdminChartsListProps = {
  state: AdminChartsState;
};

const AdminChartsList = (props: AdminChartsListProps) => {
  const adminChartsState: AdminChartsState = props.state;
  const baseColumnTitles = [
    "Precinct",
    "Township/City",
    "County",
    "Date",
    "Last Updated",
    "Status",
    "Actions",
  ];
  const columnTitles = props.state.chartType === ChartTypeEnum.PRESIDENTIAL_PRIMARY ? ["Party", ...baseColumnTitles] : baseColumnTitles;
  const [query] = useSearchParams();
  if (props.state.orderBy === "modifiedAt") {
    adminChartsState.charts.sort((a: object, b: object) => {
      // @ts-ignore
      return new Date(b[0].modifiedAt) - new Date(a[0].modifiedAt);
    });
  }

  return (
    <div className="flex flex-col w-full">
      {adminChartsState.loading && <Loading />}
      {!adminChartsState.loading && (
        <div className="flex flex-col w-full px-12 pb-36">
          {adminChartsState.charts.length > 0 &&
            adminChartsState.counties.length && (
              <div>
                {adminChartsState.charts.map((chart, index: number) => {
                  return (
                    <div
                      key={index}
                      className={`w-full ${index !== 0 ? "border-t mt-10 pt-10" : "pt-3 mb-8"
                        }`}
                    >
                      <div className="flex items-center w-full justify-items-stretch">
                        <div className="flex flex-row w-full mb-6">
                          <p className="justify-start w-full text-2xl font-semibold text-primary-blue">
                            {chart[0].county}{" "}
                            - {adminChartsState.getDate(chart[0].electionDate)}
                          </p>
                          <div className="flex flex-row justify-end w-full">
                            {chart
                              .map((elections, id) => {
                                if (elections.downloadLink) {
                                  return true;
                                }
                              })
                              .includes(true) && (
                                <button
                                  className="flex flex-row items-center text-base font-semibold cursor-pointer text-primary-blue"
                                  onClick={() =>
                                    adminChartsState.downloadAll(
                                      chart.map((c) => c.id),
                                      "charts"
                                    )
                                  }
                                >
                                  <Download className="w-6 mr-2" />
                                  <p className="mt-2">Download All Charts</p>
                                </button>
                              )}
                            {chart
                              .map((elections, id) => {
                                if (elections.fullChartDownloadLink) {
                                  return true;
                                }
                              })
                              .includes(true) && (
                                <button
                                  className="flex flex-row items-center ml-5 text-base font-semibold cursor-pointer text-primary-blue"
                                  onClick={() =>
                                    adminChartsState.downloadAll(
                                      chart.map((c) => c.id),
                                      "decks"
                                    )
                                  }
                                >
                                  <Download className="w-6 mr-2" />
                                  <p className="mt-2">Download All Decks</p>
                                </button>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className={`grid w-full grid-cols-${columnTitles.length} grid-rows-1 p-3 font-medium uppercase bg-white border font-poppins`}>
                        {columnTitles.map((title, _index) => (
                          <p key={_index}>{title}</p>
                        ))}
                      </div>
                      {chart.map((c, i: number) => {
                        return (
                          <div key={`chart-${c.id}`}>
                            <AdminChartDisplay
                              chart={c}
                              getDate={adminChartsState.getDate}
                              deleteChart={adminChartsState.deleteChart}
                              editTestDeck={adminChartsState.editTestDeck}
                              downloadChart={adminChartsState.downloadChart}
                              duplicateChart={adminChartsState.duplicateChart}
                              downloadTestDeck={
                                adminChartsState.downloadTestDeck
                              }
                              backgroundColor={
                                i % 2 === 0
                                  ? "bg-secondary-lightblue"
                                  : "bg-white"
                              }
                              regenerateChart={adminChartsState.regenerateChart}
                              regenerateTestDeck={adminChartsState.regenerateTestDeck}
                              headerLength={columnTitles.length}
                            />
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            )}
          {adminChartsState.charts.length === 0 &&
            !adminChartsState.debouncedQuery &&
            (query.get("showCompletedDeck") === "false" ||
              !query.get("showCompletedDeck")) && (
              <div className="w-full col-span-3">
                <EmptyState>No Charts Found</EmptyState>
              </div>
            )}
          {adminChartsState.charts.length === 0 &&
            !adminChartsState.debouncedQuery &&
            query.get("showCompletedDeck") === "true" && (
              <div className="w-full col-span-3">
                <EmptyState>No Completed Test Decks Found</EmptyState>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default AdminChartsList;
